import { NgModule, ModuleWithProviders } from '@angular/core';
import { CMSComponent } from '../../ui-components/cms/cms.component.prod';
import { Routes, RouterModule } from '@angular/router';

export const CMSRoutes: Routes = [
  {
    path: 'cms', redirectTo: 'home', pathMatch: 'full'
  }
];

@NgModule({
    imports: [
      RouterModule.forRoot(CMSRoutes, {useHash: true})
    ],
    declarations: [
      CMSComponent
    ],
    exports: [
      CMSComponent
    ]
})
export class CMSProdModule { }
